<template>
    <section class="projects">
        <h3 v-if="title && !$slots.title">{{ title }}</h3>
        <div class="mb-3" v-if="listData">
            <slot name="title"></slot>
        </div>
      <div v-if="!listData" class="emptyList">

        <img :src="emptyBlock.img">
        <div class="title" v-html="emptyBlock.title"></div>
        <div class="text" v-html="emptyBlock.text"></div>
        <ABtn :label="emptyBlock.btn.title" :href="emptyBlock.btn.link" class="primary w-50"/>
      </div>
        <ProjectCard v-for="(project, key) in listData" :key="key"
                     :params="project"
                     :title="project.title"
                     :category="project.category"
                     :deadline="project.deadline"
                     :datas="project.datas"
                     :messages="messages"
                     :id="project.id"
                     :requestToResponses="project.requestToResponses"
                     @compliteTask="compliteTask"
                     :responds="project.responds"
                     :url="project.url"
                     :rating_min="project.rating_min"
                     :rating_max="project.rating_max"
                     :volunteers="project.volunteers"
                     :tags="project.tags"
                     :compliteBtn="project.status=='inwork'&&!project.issetCompleteRequest?compliteBtn:false"
                     :reviewBtn="project.status=='closed'?project.reviewBtn:false"
                     :completeInfo="project.completeInfo?project.completeInfo:false"
                     :img="project.img"
                     :description="project.description"
        />
        <slot name="after"></slot>
    </section>
</template>

<script>
import {AChip, ABtn} from '~/components/ui'
import ProjectCard from "~/components/cards/ProjectCard";


export default {
    name: "ProjectListSection",
    props: {
        title: {
            type: String,
            default: 'Текущие проекты'
        },
      emptyBlock:{
        type: Object,
        default: {}
      },
        messages:{
        type: Object,
        default: {}
      },
      compliteBtn:{
        type: Object,
        default: {}
      },
        listData: {
            type: Object,
            default: {}
        }
    },
    components: {ProjectCard, AChip, ABtn},
    emits: ['compliteTask'],
    setup(props, ctx) {
        const load = () => {
            console.log('load reviews..')
        }
        const compliteTask = (v) => {
          ctx.emit('compliteTask',v);
        }
        return {
          load,
          compliteTask
        }
    }
}
</script>

<style scoped lang="scss">
.projects{
    margin-bottom: rem(85);
}
.emptyList {
  padding:75px 5px;
  border: 1px solid #D8DCDE;
  border-radius: 6px;
  text-align: center;
  img {
    margin-bottom:50px;
  }
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 44px;
    text-align: center;
    margin-bottom:25px;
  }
  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    margin-bottom:30px;
  }
}
</style>